import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CloneProjectRPC } from "./cloneProjectRPC";

export class CloneProjectRPCClientImpl extends CloneProjectRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CloneProjectRPC.Request): Promise<LeoRPCResult<CloneProjectRPC.Response, CloneProjectRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/CloneProject",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CloneProjectRPC.ResponseDTO,
      CloneProjectRPC.Errors.ErrorsDTO,
      CloneProjectRPC.Response,
      CloneProjectRPC.Errors.Errors
    >(
      response,
      "project/CloneProject",
      CloneProjectRPC.Response.fromDTO,
      CloneProjectRPC.Errors.fromDTO
    );
  }
}
